export default __webpack_public_path__ + "static/media/farexbene.c7c23f74.svg";